module.exports = __webpack_public_path__ + "img/ring_y_i_1_null@2x.a6de160d.png";